import config from "./config";
var axios = config();

export default {
  getCollegeList() {
    return axios.get("/api/Colleges/GetCollegesActive", {});
  },

  getAcademicPlans() {
    return axios.get("/api/Colleges/GetAcademicPlansActive", {});
  }
};
